module.exports = __webpack_public_path__ + "img/qinggan.6f868d07.png";